import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";

const NAV_ITEMS = [
  { label: "首页", to: "/" },
  { label: "热议榜单", to: "/rank" },
  { label: "爆料分类", to: "/#categories" },
  { label: "关于我们", to: "/about" },
  { label: "联系我们", to: "/contact" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const { pathname, hash } = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [pathname, hash]);

  const isActive = (to: string) => {
    if (to.startsWith("/#")) return pathname === "/" && hash === "#categories";
    return to === "/" ? pathname === "/" && hash !== "#categories" : pathname.startsWith(to);
  };

  return (
    <header
      className={`sticky top-0 z-50 w-full border-b transition-colors duration-300 ${
        scrolled
          ? "border-background-200 bg-background-50/95 backdrop-blur-md"
          : "border-transparent bg-background-50"
      }`}
    >
      <div className="hidden w-full items-center justify-between gap-6 border-b border-background-200/70 px-4 py-1.5 md:flex md:px-6">
        <p className="flex items-center gap-2 text-xs text-foreground-600">
          <i className="ri-flashlight-fill text-primary-500"></i>
          榜单每小时刷新 · 爆料流全天滚动更新
        </p>
        <p className="flex items-center gap-1.5 text-xs text-foreground-600">
          <i className="ri-mail-line"></i>
          contact@guadian.example.com
        </p>
      </div>

      <div className="flex w-full items-center justify-between gap-4 px-4 py-3 md:px-6">
        <Link to="/" className="flex shrink-0 items-center gap-2.5">
          <span className="flex h-10 w-10 items-center justify-center rounded-md bg-primary-500 text-background-50">
            <i className="ri-radar-line text-xl"></i>
          </span>
          <span className="flex flex-col leading-none">
            <span className="font-heading text-xl font-bold tracking-tight text-foreground-950">
              瓜点
            </span>
            <span className="mt-1 text-[11px] tracking-[0.2em] text-foreground-500">
              爆料雷达
            </span>
          </span>
        </Link>

        <nav className="hidden items-center gap-1 md:flex" aria-label="主导航">
          {NAV_ITEMS.map((item) => (
            <Link
              key={item.to}
              to={item.to}
              className={`whitespace-nowrap rounded-md px-3.5 py-2 text-sm transition-colors ${
                isActive(item.to)
                  ? "bg-primary-100 font-medium text-primary-700"
                  : "text-foreground-700 hover:bg-background-100 hover:text-primary-600"
              }`}
            >
              {item.label}
            </Link>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <Link
            to="/#hot-board"
            className="hidden whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 md:inline-flex md:items-center md:gap-1.5"
          >
            <i className="ri-fire-line"></i>
            看今日榜首
          </Link>
          <button
            type="button"
            aria-label="展开菜单"
            aria-expanded={open}
            onClick={() => setOpen((v) => !v)}
            className="flex h-10 w-10 items-center justify-center rounded-md border border-background-300 text-foreground-800 md:hidden"
          >
            <i className={open ? "ri-close-line text-xl" : "ri-menu-3-line text-xl"}></i>
          </button>
        </div>
      </div>

      {open && (
        <nav
          className="border-t border-background-200 bg-background-50 px-4 pb-4 pt-2 md:hidden"
          aria-label="移动端导航"
        >
          {NAV_ITEMS.map((item) => (
            <Link
              key={item.to}
              to={item.to}
              className="flex items-center justify-between rounded-md px-3 py-3 text-sm text-foreground-800 hover:bg-background-100"
            >
              {item.label}
              <i className="ri-arrow-right-s-line text-foreground-400"></i>
            </Link>
          ))}
        </nav>
      )}
    </header>
  );
}